



































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import UserModule from '@/store/userModule'
import ApiService from '@/services/apiService'
import { UrlType } from '@/constants/urlType'
import ExtensionModel from '@/models/extension/extensionModel'
import ExtensionModule from '@/store/extensionModule'

const userModule = getModule(UserModule)
const extensionModule = getModule(ExtensionModule)

@Component
export default class TheSidebar extends Vue {
  @Prop(Boolean) readonly value!: boolean
  isProduction = ''
  extensions: Array<ExtensionModel> = []

  get isSysAdmin() {
    return userModule.isSysAdmin
  }

  get isAdmin() {
    return userModule.isAdmin
  }

  get isUserOrAdmin() {
    return userModule.isUser || userModule.isUser
  }

  private async created(): Promise<void> {
    this.subscribeToRefreshExtensions()
    this.isProduction =
      localStorage.getItem('env') === 'prod' ? 'PRODUCTION' : 'SANDBOX'
    await this.getExtensions()
  }

  private subscribeToRefreshExtensions() {
    this.$root.$on('refreshExtensions', async () => {
      await this.getExtensions()
    })
  }

  private async getExtensions() {
    this.extensions = await ApiService.getAll<ExtensionModel>(UrlType.Extension)
  }

  public logout() {
    userModule.logout()
  }

  private SetEnvironment() {
    let environment = this.isProduction ? 'prod' : 'sandbox'
    localStorage.setItem('env', String(environment))
  }
}
